import { Injectable } from '@angular/core';
import swal, { SweetAlertType } from 'sweetalert2';

@Injectable()
export class DialogService {
    // wrapper over sweetalerts2
    // implemented only necessary methods
    // other can be found here https://github.com/limonte/sweetalert2

    constructor() { }

    public invalidDateAlert() {
        return this.errorAlert('Errore', 'Data Non Valida! <br/>Formato corretto dd/MM/yyyy');
    }

    public ws400alert(error?: any) {
        /*if(error.ModelState){
            let errors = [];
            let validationErrorDictionary = error.ModelState;
            for (var fieldName in validationErrorDictionary) {
                if (validationErrorDictionary.hasOwnProperty(fieldName)) {
                    errors.push(validationErrorDictionary[fieldName]);
                }
            }
            return this.errorAlert('Errore', errors.join("; "));
        } else */if (error.errorMessage) {
            return this.errorAlert('Errore', error.errorMessage.replace(/;/g, ';<br/>'));
        } else if (error.errorCode) {
            return this.errorAlert('Errore', 'Dati non validi, codice di errore ' + error.errorCode);
        } else {
            return this.errorAlert('Errore', 'Dati non validi');
        }
        /*if (message) {
            return this.errorAlert('Errore', message);
        } else {
            return this.errorAlert('Errore', 'Dati non validi');
        }*/
    }

    public ws403alert() {
        return this.errorAlert('Errore', 'Operazione non autorizzata');
    }

    public ws404alert() {
        return this.errorAlert('Errore', 'Oggetto non trovato');
    }

    public ws500alert() {
        return this.errorAlert('Errore', 'Si è verificato un errore interno');
    }


    public standardAlert(title: string, message: string) {
        return this.alert(title, message);
    }

    public errorAlert(title: string, message: string) {
        return this.alert(title, message, 'error');
    }

    public warningAlert(title: string, message: string) {
        return this.alert(title, message, 'warning');
    }

    public infoAlert(title: string, message: string) {
        return this.alert(title, message, 'info');
    }

    public successAlert(title: string, message: string) {
        return this.alert(title, message, 'success');
    }

    public questionConfirm(title: string, message: string, yesBtn: string, noBtn: string, yesCallback: Function, noCallback?: Function) {
        return this.confirm(title, message, 'question', yesBtn, noBtn, yesCallback, noCallback);
    }

    public infoConfirm(title: string, message: string, yesBtn: string, noBtn: string, yesCallback: Function, noCallback?: Function) {
        return this.confirm(title, message, 'info', yesBtn, noBtn, yesCallback, noCallback);
    }

    public warningConfirm(title: string, message: string, yesBtn: string, noBtn: string, yesCallback: Function, noCallback?: Function) {
        return this.confirm(title, message, 'warning', yesBtn, noBtn, yesCallback, noCallback);
    }

    public errorConfirm(title: string, message: string, yesBtn: string, noBtn: string, yesCallback: Function, noCallback?: Function) {
        return this.confirm(title, message, 'error', yesBtn, noBtn, yesCallback, noCallback);
    }

    public wellDoneAlert() {
        return this.autocloseAlert('Ben fatto', 'La tua modifica è stata salvata correttamente!', 'success');
    }

    public wellDoneDelete() {
        return this.successAlert('Ben fatto', 'azienda cancellata correttamente');
    }

    public pendingChangesConfirm(yesCallback, noCallback?) {
        if (!noCallback) {
            noCallback = () => { };
        }
        return this.warningConfirm('Attenzione', 'Ci sono delle modifiche pendenti. Vuoi uscire senza salvare?', 'Si', 'No', yesCallback, noCallback);
    }

    public warningConfirmHtml(title: string, html: string, yesBtn: string, noBtn: string, yesCallback: Function, noCallback?: Function) {
        return this.confirmHtml(title, html, 'warning', yesBtn, noBtn, yesCallback, noCallback);
    }

    public errorOccuredAlert() {
        return this.errorAlert('Errore', 'Si è verificato un errore, riprova più tardi');
    }

    public errorAlertHtml(title: string, html: string) {
        return this.alertHtml(title, html, 'error');
    }

    public infoAlertHtml(title: string, html: string) {
        return this.alertHtml(title, html, 'info');
    }

    // private sweetalerts2 methods
    private alert(title: string, message: string, type?: string) {
        return swal(title, message, <SweetAlertType>type);
    }

    private confirm(title: string, message: string, type: string, yesBtn: string, noBtn: string, yesCallback: Function, noCallback?: Function) {
        return swal({
            title: title,
            text: message,
            type: <SweetAlertType>type,
            showCancelButton: true,
            confirmButtonText: yesBtn,
            cancelButtonText: noBtn
        }).then((result) => {
            if (result.value) {
                yesCallback();
            } else if (result.dismiss === swal.DismissReason.cancel) {
                if (noCallback) {
                    noCallback();
                }
            }
        });
    }

    public prompt(title: string, text: string, confirmButtonText: string, yesCallback: (string) => void, noCallback: () => void) {
        return swal({
            title: title,
            text: text,
            input: 'text',
            showCancelButton: true,
            confirmButtonText: confirmButtonText,
            showLoaderOnConfirm: true,
            allowOutsideClick: false
        }).then(function (content) {
            // ok
            yesCallback(content);
        }, function (dismiss) {
            noCallback();
        });
    }

    private confirmHtml(title: string, html: string, type: string, yesBtn: string, noBtn: string, yesCallback: Function, noCallback?: Function) {
        if (!yesBtn) {
            yesBtn = 'YES';
        }

        if (!noBtn) {
            noBtn = 'NO';
        }

        return swal({
            title: title,
            html: html,
            type: <SweetAlertType>type,
            showCancelButton: true,
            confirmButtonText: yesBtn,
            cancelButtonText: noBtn
        }).then((result) => {
            if (result.value) {
                yesCallback();
            } else {
                if (noCallback) {
                    noCallback();
                }
            }
        });
    }

    private alertHtml(title: string, html: string, type: string) {
        return swal({
            title: title,
            html: html,
            type: <SweetAlertType>type,
            showCancelButton: false,
        });
    }

    private autocloseAlert(title: string, message: string, type: string) {
        return swal({
            title: title,
            text: message,
            type: <SweetAlertType>type,
            timer: 1200,
            showConfirmButton: false,
        });
    }

}
